import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { IPaginatorProperties } from '../../../../../core/models/paginator.interface';
import { ICarrierItem, IPriceListFilter, IService, ISubService, IVendor } from '../../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../../services/shipment-price.service';

@Component({
  selector: 'eci-price-list-filter',
  templateUrl: './price-list-filter.component.html',
  styleUrls: ['./price-list-filter.component.scss'],
})
export class PriceListFilterComponent implements OnInit {

  protected searchDelay = 300; // 300 ms
  protected itemsPerPage = 100;

  @Input() public vendors: IPaginatorProperties<IVendor> = {items: [], meta: undefined};
  @Input() public services: IPaginatorProperties<IService> = {items: [], meta: undefined};
  @Input() public carriers: IPaginatorProperties<ICarrierItem> = {items: [], meta: undefined};
  @Input() public subServices: IPaginatorProperties<ISubService> = {items: [], meta: undefined};
  @Input() public files: IPaginatorProperties<{ id: number; fileName: string }> = {items: [], meta: undefined};
  @Input() public displayedFields: string[] = ['vendors', 'services', 'subServices'];

  @Output() public onFilterSearch: EventEmitter<IPriceListFilter> = new EventEmitter<IPriceListFilter>(undefined);

  public vendorSearch: FormControl = new FormControl('');
  public serviceSearch: FormControl = new FormControl('');
  public subServiceSearch: FormControl = new FormControl('');
  public carriersSearch: FormControl = new FormControl('');
  public filesSearch: FormControl = new FormControl('');
  public form: FormGroup;
  constructor(private shipmentPriceSvc: ShipmentPriceService) {
  }

  ngOnInit(): void {
    this.form = this.initializeForm();
    this.searchSubscriber();
    // this.filterSubscriber<IPaginatorProperties<ICarriersListItem>>('carriers', this.carriers, this.carriersSearch);
  }

  private initializeForm(): FormGroup {
    return new FormGroup({
      search: new FormControl(''),
      vendors: new FormControl(''),
      services: new FormControl(''),
      subServices: new FormControl(''),
      carriers: new FormControl(''),
      files: new FormControl(''),
    });

  }

  public onSubmit(): void {
    this.onFilterSearch.emit(this.form.value);
  }

  private searchSubscriber(): void {
    this.form.get('search').valueChanges
      .pipe(debounceTime(this.searchDelay))
      .subscribe(() => {
        this.onFilterSearch.emit(this.form.value);
      });
  }

  public getParams<T>(path: string, object: IPaginatorProperties<T>,
                      page: number = 1, q: string = ''): void {
    this.shipmentPriceSvc.get<IPaginatorProperties<T>>(path, page, this.itemsPerPage, q, {select: 'dropdown'}, 'name', 'ASC')
      .subscribe((data) => {
        if (!data) {
          return;
        }
        object.items = [...object.items, ...data.items];
        object.meta = data?.meta;
      });
  }

  public clearFilters(): void {
    this.form.setValue({
      search: '',
      vendors: '',
      services: '',
      subServices: '',
      carriers: '',
      files: '',
    });

  }

  public compare(o: IPaginatorProperties<any>): boolean {
    return o?.meta?.currentPage === o?.meta?.totalPages;
  }

  private filterSubscriber<T>(path: string, obj: IPaginatorProperties<T>, search: FormControl): void {
    search.valueChanges.pipe(debounceTime(this.searchDelay))
      .subscribe((value) => {
        console.log('filterSubscriber', value);
        if (this.compare(obj)) {
          return;
        }
        this.getParams<T>(path,
          obj,
          obj?.meta?.currentPage + 1 || 1,
          value);
      });
  }
}
